import FFTC from "components/Stacker/constants/FormFieldTypeConstants"

const productConfigurationConfig = {
  PINKY_PRODUCTS: {
    PRODUCT_TYPE: "pinkyring",
    WOMEN: [
      {
        THEME_VALUE: "women",
        METAL_VALUE: "gold",
        PRODUCT_NAME: "18k Gold",
        PRODUCT_ID: "R14123 88",
        PRICE: "$1,000",
        PRICE_CA: "$1,250",
        BG_VIDEO: {
          vidId: "5797243030001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurman/gold_main_video_thumb",
        },
      },
      {
        THEME_VALUE: "women",
        METAL_VALUE: "silver",
        PRODUCT_NAME: "Silver",
        PRODUCT_ID: "R14124 SS",
        PRICE: "$375",
        PRICE_CA: "$475",
        BG_VIDEO: {
          vidId: "5797239786001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurman/silver_main_video_thumb",
        },
      },
    ],
    MEN: [
      {
        THEME_VALUE: "men",
        METAL_VALUE: "gold",
        PRODUCT_NAME: "18K GOLD",
        PRODUCT_ID: "R25293M88",
        PRICE: "$2,700",
        PRICE_CA: "$3,400",
        BG_VIDEO: {
          vidId: "5850887930001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurmanNew/mens_gold_main_video_thumb",
        },
      },
      {
        THEME_VALUE: "men",
        METAL_VALUE: "silver",
        PRODUCT_NAME: "Silver",
        PRODUCT_ID: "R25293MSS",
        PRICE: "$395",
        PRICE_CA: "$500",
        BG_VIDEO: {
          vidId: "5850878582001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurmanNew/mens_silver_main_video_thumb",
        },
      },
    ],
  },
  PENDANT_PRODUCTS: {
    PRODUCT_TYPE: "pendant",
    WOMEN: [
      {
        THEME_VALUE: "women",
        METAL_VALUE: "gold",
        PRODUCT_NAME: "18k Gold",
        PRODUCT_ID: "N16017 88",
        PRICE: "$850",
        PRICE_CA: "$1,100",
        BG_VIDEO: {
          vidId: "6054440531001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurmanNew/CableNecklaces_PDP_Gold",
        },
      },
      {
        THEME_VALUE: "women",
        METAL_VALUE: "silver",
        PRODUCT_NAME: "Silver",
        PRODUCT_ID: "N16018 SS",
        PRICE: "$465",
        PRICE_CA: "$600",
        BG_VIDEO: {
          vidId: "6018879537001",
          dataAccount: "5088318296001",
          poster:
            "https://img.davidyurman.com/is/image/DavidYurmanNew/CableNecklaces_PDP_Silver",
        },
      },
    ],
  },
  DESIGN_VALUES: ["monogram", "motif"],
  PRC_SLIDE_TRANSITION: "pinkyringslide",
  PRC_SLIDEBACK_TRANSITION: "pinkyringslideBack",
  DEFAULT_VALUE: "default",
  FONT_VALUES: [
    {
      name: "Deco",
      value: "deco",
      code: "DEC",
    },
    {
      name: "Serif",
      value: "serif",
      code: "SER",
    },
    {
      name: "Script",
      value: "script",
      code: "SCR",
    },
  ],
  ICON_VALUES: [
    {
      symbols: [
        {
          name: "Heart",
          value: "heart",
          code: "13",
        },
        {
          name: "Love",
          value: "love",
          code: "14",
        },
        {
          name: "Evil eye",
          value: "evil-eye",
          code: "15",
        },
        {
          name: "Star",
          value: "star",
          code: "16",
        },
        {
          name: "Moon",
          value: "moon",
          code: "17",
        },
        {
          name: "Butterfly",
          value: "butterfly",
          code: "18",
        },
        {
          name: "Bee",
          value: "bee",
          code: "19",
        },
        {
          name: "Star of David",
          value: "star-of-david",
          code: "20",
        },
        {
          name: "Cross",
          value: "cross",
          code: "21",
        },
        {
          name: "Om",
          value: "om",
          code: "22",
        },
        {
          name: "Hamsa",
          value: "hamsa",
          code: "23",
        },
        {
          name: "Peace sign",
          value: "peace-sign",
          code: "24",
        },
        {
          name: "Horseshoe",
          value: "horseshoe",
          code: "25",
        },
        {
          name: "Eye of ra",
          value: "eye-of-ra",
          code: "26",
        },
        {
          name: "Skull",
          value: "skull",
          code: "27",
        },
        {
          name: "Compass",
          value: "compass",
          code: "28",
        },
        {
          name: "Anchor",
          value: "anchor",
          code: "29",
        },
        {
          name: "Sugar skull",
          value: "sugar-skull",
          code: "30",
        },
      ],
      zodiac: [
        {
          name: "Aquarius",
          value: "aquarius",
          code: "11",
        },
        {
          name: "Pisces",
          value: "pisces",
          code: "12",
        },
        {
          name: "Aries",
          value: "aries",
          code: "1",
        },
        {
          name: "Taurus",
          value: "taurus",
          code: "2",
        },
        {
          name: "Gemini",
          value: "gemini",
          code: "3",
        },
        {
          name: "Cancer",
          value: "cancer",
          code: "4",
        },
        {
          name: "Leo",
          value: "leo",
          code: "5",
        },
        {
          name: "Virgo",
          value: "virgo",
          code: "6",
        },
        {
          name: "Libra",
          value: "libra",
          code: "7",
        },
        {
          name: "Scorpio",
          value: "scorpio",
          code: "8",
        },
        {
          name: "Sagittarius",
          value: "sagittarius",
          code: "9",
        },
        {
          name: "Capricorn",
          value: "capricorn",
          code: "10",
        },
      ],
      sororities: [
        {
          name: "Alpha Chi Omega",
          value: "alpha-chi-omega",
          code: "41",
        },
        {
          name: "Alpha Delta Pi",
          value: "alpha-delta-pi",
          code: "42",
        },
        {
          name: "Alpha Epsilon Phi",
          value: "alpha-epsilon-phi",
          code: "43",
        },
        {
          name: "Alpha Gamma Delta",
          value: "alpha-gamma-delta",
          code: "44",
        },
        {
          name: "Alpha Omicron Pi",
          value: "alpha-omicron-pi",
          code: "45",
        },
        {
          name: "Alpha Phi",
          value: "alpha-phi",
          code: "46",
        },
        {
          name: "Alpha Sigma Alpha",
          value: "alpha-sigma-alpha",
          code: "47",
        },
        {
          name: "Alpha Sigma Tau",
          value: "alpha-sigma-tau",
          code: "48",
        },
        {
          name: "Alpha Xi Delta",
          value: "alpha-xi-delta",
          code: "49",
        },
        {
          name: "Chi Omega",
          value: "chi-omega",
          code: "50",
        },
        {
          name: "Delta Delta Delta",
          value: "delta-delta-delta",
          code: "51",
        },
        {
          name: "Delta Gamma",
          value: "delta-gamma",
          code: "52",
        },
        {
          name: "Delta Phi Epsilon",
          value: "delta-phi-epsilon",
          code: "53",
        },
        {
          name: "Delta Zeta",
          value: "delta-zeta",
          code: "54",
        },
        {
          name: "Gamma Phi Beta",
          value: "gamma-phi-beta",
          code: "55",
        },
        {
          name: "Kappa Alpha Theta",
          value: "kappa-alpha-theta",
          code: "56",
        },
        {
          name: "Kappa Delta",
          value: "kappa-delta",
          code: "57",
        },
        {
          name: "Kappa Kappa Gamma",
          value: "kappa-kappa-gamma",
          code: "58",
        },
        {
          name: "Phi Mu",
          value: "phi-mu",
          code: "59",
        },
        {
          name: "Phi Sigma Sigma",
          value: "phi-sigma-sigma",
          code: "60",
        },
        {
          name: "Pi Beta Phi",
          value: "pi-beta-phi",
          code: "61",
        },
        {
          name: "Sigma Delta Tau",
          value: "sigma-delta-tau",
          code: "62",
        },
        {
          name: "Sigma Kappa",
          value: "sigma-kappa",
          code: "63",
        },
        {
          name: "Sigma Sigma Sigma",
          value: "sigma-sigma-sigma",
          code: "64",
        },
        {
          name: "Theta Phi Alpha",
          value: "theta-phi-alpha",
          code: "65",
        },
        {
          name: "Zeta Tau Alpha",
          value: "zeta-tau-alpha",
          code: "66",
        },
      ],
    },
  ],
  PINKY_RING_TEXT: {
    type: FFTC.TEXT,
    name: "pinky-ring-text",
    id: "pinky-ring-text",
    maxLength: 3,
    "aria-label": "textvalue",
  },
}

export default productConfigurationConfig
